export default __webpack_public_path__ + "static/casablanca-3-06cec66e29f819248b3465d5848ed50f.jpg";